export const sanitizeNumbers = (event: React.ChangeEvent<HTMLInputElement>) => {
  event.target.value = event.target.value.replace(/[^0-9]/g, '');
};

export const sanitizeNumbersLength = (
  event: React.ChangeEvent<HTMLInputElement>,
  maxLength: number
) => {
  const sensitizedValue = event.target.value.replace(/[^0-9]/g, '');
  event.target.value = sensitizedValue?.slice(
    0,
    Math.min(sensitizedValue.length, maxLength)
  );
};
